module.exports = __webpack_public_path__ + "bbf8667975770cd1b95d89fd211476b2.png";